import { cn } from '@/lib/utils';
import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  label?: string;
  className?: string;
  href?: string;
}
export function CTAButton({
  label = 'QUIERO MI MEGAPACK AHORA',
  className = '',
  href = 'https://estetica-digital-pro.impultienda.ar/checkout'
}: CTAButtonProps) {
  return <a href={href} className={cn(`group inline-flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-[#4656f5] via-[#8a55df] to-[#ff7396] px-8 py-4 text-sm sm:text-base font-bold uppercase tracking-wide text-white shadow-lg shadow-indigo-500/25 transition-all hover:brightness-105 hover:shadow-xl hover:-translate-y-0.5 focus:outline-none focus-visible:ring-4 focus-visible:ring-indigo-300/50 ${className}`, "w-[228px] h-[71px] items-center justify-center", "w-[277px] h-[48px] items-center justify-center")} data-id="element-90" data-mp="2fya5xcs5315r">
      {label}
      <ArrowRightIcon className="h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-91" data-mp="38oshl26xiaus" />
    </a>;
}